export default __webpack_public_path__ + "static/media/banner8.a6845489.jpeg";